import { useCallback } from 'react';
import { Icon } from '@iconify/react';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import { Box, Button, Typography } from '@mui/material';
import { VerifyCodeForm } from 'src/components/authentication/verify-code/index';
import axios from 'src/utils/axios';
import { formatPhoneNumber } from 'src/utils/formatPhoneNumber';
import OtpResendBlock from 'src/components/shared/OtpResendBlock';
import { useOtpResend } from 'src/hooks/useOtpResend';

export default function VerifyCode({
  phone,
  onBack,
  onExtendSessionSuccess,
  onLoginSuccess,
  returnUrl,
  skipTermsOfService = false,
  initialCooldownSeconds = 0,
}) {
  const sendFn = useCallback(
    () =>
      axios
        .post('user_phone_login/send_sms_code/', { phone })
        .then((r) => r.data),
    [phone]
  );

  const resend = useOtpResend({ sendFn, initialCooldownSeconds });

  return (
    <>
      <Box sx={{ maxWidth: 480, mx: 'auto' }}>
        <Button
          size="small"
          onClick={onBack}
          startIcon={<Icon icon={arrowIosBackFill} width={20} height={20} />}
          sx={{ mb: 3 }}
        >
          Back
        </Button>

        <Typography
          variant="h3"
          sx={{
            marginBottom: '16px',
          }}
        >
          Please check your phone!
        </Typography>
        <Typography sx={{ color: 'text.secondary' }}>
          We have sent you a 6-digit confirmation code to{' '}
          {formatPhoneNumber(phone.replace('+1', ''))}, please enter the
          confirmation code to login.
        </Typography>

        <Box sx={{ mt: 5, mb: 3 }}>
          <VerifyCodeForm
            onExtendSessionSuccess={onExtendSessionSuccess}
            onLoginSuccess={onLoginSuccess}
            returnUrl={returnUrl}
            skipTermsOfService={skipTermsOfService}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <OtpResendBlock resend={resend} />
        </Box>
      </Box>
    </>
  );
}
